import { render } from "./QrcodeReader.vue?vue&type=template&id=dbbb2e16"
import script from "./QrcodeReader.vue?vue&type=script&lang=js"
export * from "./QrcodeReader.vue?vue&type=script&lang=js"

import "./QrcodeReader.vue?vue&type=style&index=0&id=dbbb2e16&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__